export const CONFIG = {
  //API_URL: "http://lumberjack.test/api",
  API_URL: "https://magazzino.effebiparquet.com/api",
};
